"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const firebase_1 = __importDefault(require("firebase"));
const rxjs_1 = require("rxjs");
const firebaseui = __importStar(require("firebaseui"));
const util_rx_1 = require("./util_rx");
let firebaseAuthUI = null;
function firebaseAuthConfigure() {
    return util_rx_1.promise$(() => firebase_1.default.auth().setPersistence(firebase_1.default.auth.Auth.Persistence.LOCAL));
}
exports.firebaseAuthConfigure = firebaseAuthConfigure;
function firebaseCurrentUser$() {
    const auth = firebase_1.default.auth();
    return new rxjs_1.Observable(subscriber => {
        subscriber.next(auth.currentUser);
        const subs = auth.onAuthStateChanged(user => subscriber.next(user), error => subscriber.error(error));
        return () => {
            subs();
        };
    });
}
exports.firebaseCurrentUser$ = firebaseCurrentUser$;
function firebaseLogout$() {
    return util_rx_1.promise$(() => firebase_1.default.auth().signOut());
}
exports.firebaseLogout$ = firebaseLogout$;
function firebaseLoginStart$(element) {
    return new rxjs_1.Observable(subscriber => {
        console.log("++++ firebaseLoginStart$");
        const config = {
            // ---- Sign in
            signInSuccessUrl: "/",
            signInOptions: [
                // Leave the lines as is for the providers you want to offer your users.
                firebase_1.default.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase_1.default.auth.EmailAuthProvider.PROVIDER_ID,
            ],
            signInFlow: "popup",
            // ---- Policy and TOS
            // tosUrl and privacyPolicyUrl accept either url string or a callback
            // function.
            // Terms of service url/callback.
            tosUrl: "<your-tos-url>",
            // Privacy policy url/callback.
            privacyPolicyUrl: function () {
                window.location.assign("<your-privacy-policy-url>");
            },
            // ---- Callbacks
            callbacks: {
                signInSuccessWithAuthResult(authResult, redirectUrl) {
                    const user = authResult.user;
                    console.log("++++ firebaseAuth signInSuccessWithAuthResult", user, authResult);
                    subscriber.next(user);
                    subscriber.complete();
                    return false;
                },
                signInFailure(error) {
                    subscriber.error(error);
                    return new Promise((resolve, reject) => { });
                }
            },
        };
        // The start method will wait until the DOM is loaded.
        firebaseAuthUI = firebaseAuthUI || new firebaseui.auth.AuthUI(firebase_1.default.auth());
        firebaseAuthUI.start(element, config);
        return () => {
            firebaseAuthUI && firebaseAuthUI.reset();
        };
    });
}
exports.firebaseLoginStart$ = firebaseLoginStart$;
;
